import React from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';

const Body = ({ selectedTasks, role }) => {
    return(
        <div className="sign-dialog">
        {selectedTasks.map(task =>
                <div  key={task.taskId} className="sign-dialog--task">
            <div>ROLE:</div>
    <div>{task.role}</div>
    <div>TASK:</div>
    <div>{task.description}</div>
    </div>
)}
</div>
);
}

const TaskRequestDialog = ({ tasks, role, onClose, onAccept, ...props }) =>
<ConfirmationDialog
{...props}
onClose = { onClose }
cancelButton={{
    action: onClose,
        label: 'NO, CANCEL'
}}
acceptButton={{
    action: onAccept,
        label: 'YES, REQUEST'
}}
header="Are you sure you want to request a signature for the following tasks?"
body={<Body selectedTasks={tasks} />}
/>;

export default TaskRequestDialog;